import React, { useRef, useEffect } from 'react';


interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    src: string; // 图片地址
}


/**
 * 图片在视口内才加载
 * @param imgProps
 */
const ViewportImg = (imgProps: ImageProps) => {
    const { src, ...restProps } = imgProps;
    const imgRef = useRef<any>(null);


    useEffect(() => {
        if (imgRef.current) {
            if (imgRef.current.src !== src) {
                imgRef.current.src === src;
            }
            // 判断图片是否进入视口内
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // 进入视口
                        const img: any = entry.target || {};
                        const tempUrl = (img.dataset || {}).url;
                        img.src = tempUrl;
                    }
                });
            }, {
                // 全部进入视口
                threshold: 1, 
            });
            observer.observe(imgRef.current);
        }
    }, [imgRef.current, src]);


    return (
        <img 
            {...restProps}
            data-url={src} 
            ref={imgRef} 
            loading="lazy" 
        />
    );
};


export { ViewportImg };